export const FREQUENCY_OPTION = 'frequency_option'
export const FREQUENCY_OPTION_DEFAULT = 'frequency_option_default'
export const FREQUENCY_OPTION_AUTOMATIC = 'frequency_option_automatic'
export const FREQUENCY_IMPRESSIONS = 'frequency_impressions'
export const FREQUENCY_DAYS = 'frequency_days'

export const FREQUENCY_OPTION_NO_MORE_THAN_3_TIMES_EVERY_7_DAYS = 'frequency_option_no_more_than_3_times_every_7_days'
export const FREQUENCY_OPTION_NO_MORE_THAN_ONCE_A_DAY = 'frequency_option_no_more_than_once_a_day'

export const frequencyInitialValues = {
  [FREQUENCY_OPTION]: FREQUENCY_OPTION_DEFAULT,
  [FREQUENCY_IMPRESSIONS]: '2',
  [FREQUENCY_DAYS]: '7'
}
